import { createFileRoute, redirect } from '@tanstack/react-router';

// Back-compat shim: the standalone IVR menu builder is gone — Call Flows draws
// the same keypad tree. A saved bookmark or copied link to the builder would
// otherwise hit the app's not-found route, so send it to the replacement.
export const Route = createFileRoute('/_dashboard/dashboard/settings/call-settings/ivr/new')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/call-settings', search: { tab: 'flows' } });
  },
});
